 import React from 'react'
 import AboutBackground from "../Assets/about-background.png";
 import Programa from "../Assets/programa.jpeg"
 import { BsFillPlayCircleFill } from 'react-icons/bs';
 
 const About = () => {
   return (
     <div id='programa' className='about-section-container'>
        <div className='about-background-image-container'>
            <img src={AboutBackground} alt="" />                         
        </div>
        <div className='about-section-image-container'>
            <img src={Programa} alt="" />                         
        </div>
        <div className='about-section-text-container'>
            <p className='primary-subheading'>Programa de actividades</p>
            <h1 className='primary-heading'>Descarga aquí el programa</h1>
            <div className='about-buttons-container'>
                <a className='secondary-button' href='https://www.tlavc-peru.org/documentos/PROGRAMA.pdf' target='_blank'>Descarga aquí</a>
                <button className='watch-video-button' type="">{BsFillPlayCircleFill}</button>
                
            </div>
        </div>
        
     </div>
   )
 }
 
 export default About